import moment from "moment-timezone";
var ymdPattern = "YYYY-MM-DD";
var DAYS = "days";
var DAY = "day";
export var convertToYMDWithoutTimeZone = function (date) {
    return date.format(ymdPattern);
};
export var getTodayAsYMD = function (timeZone) {
    return moment().tz(timeZone).format(ymdPattern);
};
export var getYesterdayAsYMD = function (timeZone) {
    return moment().tz(timeZone).subtract(1, DAYS).startOf(DAY).format(ymdPattern);
};
export var getTodayAsMoment = function (timeZone) {
    return moment().tz(timeZone);
};
export var converToMoment = function (date, timeZone) {
    return moment(date).tz(timeZone);
};
